import { useIsMobile } from '@/global-hooks/use-is-mobile';
import { GlobalHeader } from '@/shared/design-system';
import { UserDropdown } from '@/shared/design-system/components/UserDropdown';

import { HeaderActions } from './components/header-actions';
import { MobileHeader } from './components/mobile-header';
import { NotificationMessages } from './components/notification-messages';
import { SidebarToggle } from './components/sidebar-toggle';
import { WalletChip } from './components/wallet-chip';

export const Header = () => {
  const isMobile = useIsMobile();

  if (isMobile) {
    return <MobileHeader />;
  }

  return (
    <GlobalHeader
      sidebarToggle={<SidebarToggle />}
      notice={<NotificationMessages />}
      actions={<HeaderActions />}
      wallet={<WalletChip />}
      userDropdown={<UserDropdown />}
    />
  );
};
